// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2740px%27 height=%2740px%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27 stroke=%27%23000000%27 stroke-width=%271.2%27%3E%3Cg id=%27SVGRepo_bgCarrier%27 stroke-width=%270%27%3E%3C/g%3E%3Cg id=%27SVGRepo_tracerCarrier%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/g%3E%3Cg id=%27SVGRepo_iconCarrier%27%3E%3Cpath d=%27M19.5 12V12C19.5 10.5955 19.5 9.89331 19.1629 9.38886C19.017 9.17048 18.8295 8.98298 18.6111 8.83706C18.1067 8.5 17.4045 8.5 16 8.5H14.1569C13.3394 8.5 12.9306 8.5 12.5631 8.34776C12.1955 8.19552 11.9065 7.90489 11.3284 7.32843L10.6716 6.67157C10.0935 6.09351 9.80448 5.80448 9.43694 5.65224C9.0694 5.5 8.66065 5.5 7.84315 5.5H7.5C5.61438 5.5 4.67157 5.5 4.08579 6.08579C3.5 6.67157 3.5 7.61438 3.5 9.5V14.5C3.5 16.3856 3.5 17.3284 4.08579 17.9142C4.67157 18.5 5.61438 18.5 7.5 18.5H12%27 stroke=%27%23222222%27%3E%3C/path%3E%3Ccircle cx=%2716.5%27 cy=%2716.5%27 r=%272.5%27 stroke=%27%23222222%27%3E%3C/circle%3E%3Cpath d=%27M19.5 19.5L21 21%27 stroke=%27%23222222%27 stroke-linecap=%27round%27%3E%3C/path%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2740px%27 height=%2740px%27 viewBox=%272 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27 stroke=%27%23000000%27 stroke-width=%271.2%27%3E%3Cg id=%27SVGRepo_bgCarrier%27 stroke-width=%270%27%3E%3C/g%3E%3Cg id=%27SVGRepo_tracerCarrier%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/g%3E%3Cg id=%27SVGRepo_iconCarrier%27%3E%3Cpath d=%27M19.5 14V12.5C19.5 10.6144 19.5 9.67157 18.9142 9.08579C18.3284 8.5 17.3856 8.5 15.5 8.5H14.1569C13.3394 8.5 12.9306 8.5 12.5631 8.34776C12.1955 8.19552 11.9065 7.90489 11.3284 7.32843L10.6716 6.67157C10.0935 6.09351 9.80448 5.80448 9.43694 5.65224C9.0694 5.5 8.66065 5.5 7.84315 5.5H7.5C5.61438 5.5 4.67157 5.5 4.08579 6.08579C3.5 6.67157 3.5 7.61438 3.5 9.5V14.5C3.5 16.3856 3.5 17.3284 4.08579 17.9142C4.67157 18.5 5.61438 18.5 7.5 18.5H15%27 stroke=%27%23222222%27%3E%3C/path%3E%3Cpath d=%27M17 18.5H19.5M19.5 18.5H22M19.5 18.5V21M19.5 18.5V16%27 stroke=%27%23222222%27%3E%3C/path%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg width=%2740px%27 height=%2740px%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg id=%27SVGRepo_bgCarrier%27 stroke-width=%270%27%3E%3C/g%3E%3Cg id=%27SVGRepo_tracerCarrier%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/g%3E%3Cg id=%27SVGRepo_iconCarrier%27%3E%3Cpath d=%27M12 5H7C5.89543 5 5 5.89543 5 7V16H19V12.5%27 stroke=%27%23000000%27 stroke-width=%271.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/path%3E%3Cpath d=%27M3 16H21V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V16Z%27 stroke=%27%23000000%27 stroke-width=%271.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/path%3E%3Cpath d=%27M18.5 3V9M18.5 9L16 6.5M18.5 9L21 6.5%27 stroke=%27%23000000%27 stroke-width=%271.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/path%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg width=%2740px%27 height=%2740px%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg id=%27SVGRepo_bgCarrier%27 stroke-width=%270%27%3E%3C/g%3E%3Cg id=%27SVGRepo_tracerCarrier%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/g%3E%3Cg id=%27SVGRepo_iconCarrier%27%3E%3Cpath d=%27M13 4H8.8C7.11984 4 6.27976 4 5.63803 4.32698C5.07354 4.6146 4.6146 5.07354 4.32698 5.63803C4 6.27976 4 7.11984 4 8.8V15.2C4 16.8802 4 17.7202 4.32698 18.362C4.6146 18.9265 5.07354 19.3854 5.63803 19.673C6.27976 20 7.11984 20 8.8 20H15.2C16.8802 20 17.7202 20 18.362 19.673C18.9265 19.3854 19.3854 18.9265 19.673 18.362C20 17.7202 20 16.8802 20 15.2V11%27 stroke=%27%23000000%27 stroke-width=%271.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/path%3E%3Cpath d=%27M4 16L8.29289 11.7071C8.68342 11.3166 9.31658 11.3166 9.70711 11.7071L13 15M13 15L15.7929 12.2071C16.1834 11.8166 16.8166 11.8166 17.2071 12.2071L20 15M13 15L15.25 17.25%27 stroke=%27%23000000%27 stroke-width=%271.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/path%3E%3Cpath d=%27M18 3V8M18 8L16 6M18 8L20 6%27 stroke=%27%23000000%27 stroke-width=%271.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/path%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg fill=%27%23000000%27 width=%2740px%27 height=%2740px%27 viewBox=%27-2 0 48 36%27 version=%271.1%27 preserveAspectRatio=%27xMidYMid meet%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 stroke=%27%23000000%27 stroke-width=%270.00036%27%3E%3Cg id=%27SVGRepo_bgCarrier%27 stroke-width=%270%27%3E%3C/g%3E%3Cg id=%27SVGRepo_tracerCarrier%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke=%27%23CCCCCC%27 stroke-width=%271.0799999999999998%27%3E%3C/g%3E%3Cg id=%27SVGRepo_iconCarrier%27%3E%3Ctitle%3Edeploy-line%3C/title%3E%3Cpath class=%27clr-i-outline clr-i-outline-path-1%27 d=%27M33,2H22.1a1,1,0,0,0,0,2h8.53l-8.82,9a1,1,0,1,0,1.43,1.4L32,5.46V13.9a1,1,0,0,0,2,0V3A1,1,0,0,0,33,2Z%27%3E%3C/path%3E%3Cpath class=%27clr-i-outline clr-i-outline-path-2%27 d=%27M11.54,10.73l-9,5.17a1,1,0,0,0-.5.87v11a1,1,0,0,0,.5.87l9,5.15a1,1,0,0,0,1,0l9-5.15a1,1,0,0,0,.5-.87v-11a1,1,0,0,0-.5-.87l-9-5.17A1,1,0,0,0,11.54,10.73ZM11,31.08l-7-4V18.44l7,4ZM12,21,4.81,16.87,12,12.78l7.21,4.12Zm8,6.09-7,4V22.44l7-4Z%27%3E%3C/path%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3Csvg fill=%27%23b2b2b2%27 width=%2740px%27 height=%2740px%27 viewBox=%27-2 0 48 36%27 version=%271.1%27 preserveAspectRatio=%27xMidYMid meet%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 stroke=%27%23000000%27 stroke-width=%270.00036%27%3E%3Cg id=%27SVGRepo_bgCarrier%27 stroke-width=%270%27%3E%3C/g%3E%3Cg id=%27SVGRepo_tracerCarrier%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke=%27%23CCCCCC%27 stroke-width=%271.0799999999999998%27%3E%3C/g%3E%3Cg id=%27SVGRepo_iconCarrier%27%3E%3Ctitle%3Edeploy-line%3C/title%3E%3Cpath class=%27clr-i-outline clr-i-outline-path-1%27 d=%27M33,2H22.1a1,1,0,0,0,0,2h8.53l-8.82,9a1,1,0,1,0,1.43,1.4L32,5.46V13.9a1,1,0,0,0,2,0V3A1,1,0,0,0,33,2Z%27%3E%3C/path%3E%3Cpath class=%27clr-i-outline clr-i-outline-path-2%27 d=%27M11.54,10.73l-9,5.17a1,1,0,0,0-.5.87v11a1,1,0,0,0,.5.87l9,5.15a1,1,0,0,0,1,0l9-5.15a1,1,0,0,0,.5-.87v-11a1,1,0,0,0-.5-.87l-9-5.17A1,1,0,0,0,11.54,10.73ZM11,31.08l-7-4V18.44l7,4ZM12,21,4.81,16.87,12,12.78l7.21,4.12Zm8,6.09-7,4V22.44l7-4Z%27%3E%3C/path%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}
body,
html {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  height: 100%;
  max-height: 100%;
  padding: 0;
  margin: 0;
}
a:link {
  text-decoration: none;
}
.content {
  position: relative;
  width: 100%;
  height: 100%;
}
.content > .message {
  width: 100%;
  height: 100%;
  text-align: center;
  display: table;
  font-size: 16px;
  color: #111;
}
.content > .message .note {
  vertical-align: middle;
  text-align: center;
  display: table-cell;
}
.content > .message .error .details {
  max-width: 500px;
  font-size: 12px;
  margin: 20px auto;
  text-align: left;
}
.content > .message .error pre {
  border: solid 1px #CCC;
  background: #EEE;
  padding: 10px;
}
.content:not(.with-error) .error,
.content.with-error .intro,
.content.with-diagram .intro {
  display: none;
}
.content .canvas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.content .canvas,
.content.with-error .canvas {
  visibility: hidden;
}
.content.with-diagram .canvas {
  visibility: visible;
}
.buttons {
  position: fixed;
  bottom: 20px;
  left: 20px;
  padding: 0;
  margin: 0;
  list-style: none;
}
.buttons > li {
  display: inline-block;
  margin-right: 10px;
}
.buttons > li > a {
  background: #ddd;
  border: solid 1px #666;
  display: inline-block;
  padding: 5px;
}
.buttons a {
  opacity: 0.3;
}
.buttons a.active {
  opacity: 1;
}
#js-properties-panel {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 260px;
  border-left: 1px solid #ccc;
  overflow: auto;
}
#js-properties-panel:empty {
  display: none;
}
#js-properties-panel > .djs-properties-panel {
  padding-bottom: 70px;
  min-height: 100%;
}
/** widgets **/
.io-control {
  background: #fafafa;
  border-radius: 2px;
  border: solid 1px #afafaf;
  padding-top: 5px;
  padding-left: 5px;
}
.cjs-powered-by,
.bjs-powered-by {
  padding-bottom: 2px;
}
.close {
  color: #333 !important;
  font-size: 21px;
  font-weight: 700 !important;
  opacity: 0.6;
  line-height: 1;
  vertical-align: middle;
  margin-left: 5px;
}
.close:hover {
  opacity: 1;
}
.io-control .vr {
  height: 40px;
  display: inline-block;
  border-right: solid 1px #ebe9e9;
}
.io-control hr {
  border: none;
  border-top: solid 1px #ebe9e9;
  width: 15px;
}
.io-control-list .vr {
  margin-right: 0;
}
.io-control-list {
  list-style: none;
}
.io-control-list a,
.io-control-list a:visited,
.io-control-list button {
  padding: 0;
  outline: none;
  cursor: pointer;
  font-size: 22px;
  line-height: 26px;
  color: #c0c0c0;
  background: none;
  border: none;
}
.io-control-list a:hover,
.io-control-list a:visited:hover,
.io-control-list button:hover {
  color: #c0c0c0;
}
.io-control-list a.inactive,
.io-control-list a:visited.inactive,
.io-control-list button.inactive {
  color: #c0c0c0;
  cursor: default;
}
.io-control-list.io-horizontal,
.io-control-list.io-horizontal li {
  display: inline-block;
}
.io-control-list.io-horizontal li + li {
  margin-left: 5px;
}
.io-control-list.io-horizontal a {
  padding: 2px;
}
.io-about {
  position: fixed;
  right: 10px;
}
.io-about li + li {
  margin-left: 15px;
}
body.shown .io-about {
  right: 90px;
}
.io-about a {
  font-size: 13px;
  line-height: 20px;
  font-weight: normal;
}
.io-about a:hover {
  background: #F0F0F0;
  border-radius: 2px;
}
.io-import {
  margin-right: 10px;
}
.io-import-export {
  position: fixed;
  left: 10px;
  bottom: 10px;
}
.io-import-export .inactive {
  opacity: 0.3;
}
.djs-palette {
  left: 10px !important;
  top: 10px !important;
}
.io-about {
  bottom: 8px;
}
.io-zoom-controls {
  width: auto;
  position: fixed;
  right: 10px;
  bottom: 80px;
}
.io-editing-tools {
  width: auto;
  position: fixed;
  right: 5px;
  top: 5px;
  display: none;
}
.io-editing-tools .io-control {
  margin-left: 10px;
}
.io-editing-tools .io-control button {
  margin: 0;
}
.io-zoom-reset {
  margin-bottom: 10px;
}
/**
 * import warnings dialog
 */
.import-warnings .error-log {
  width: 100%;
}
.icon-open {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.icon-plus-circled {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.icon-download {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.icon-image {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.icon-publish {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.icon-publish-disabled {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.button-properties {
  color: #2800ee;
  background: #fff;
  font-size: 13px;
  border: none;
  cursor: pointer;
  margin: -5px;
}
.button-publish {
  color: #333;
  background: #fafafa;
  border: solid 1px #c0c2cb;
  cursor: pointer;
  font-size: 14px;
  border-radius: 2px;
  padding: 4px 2px 0px 6px;
  margin: 5px 10px 15px;
}
.button-publish-properties {
  color: #333;
  background: #fafafa;
  border: solid 1px #c0c2cb;
  cursor: pointer;
  font-size: 14px;
  border-radius: 2px;
  padding: 4px 2px 0px 4px;
  margin: 5px 0px 15px 12px;
}
.slideout-menu {
  position: fixed;
  top: 0;
  right: 0px;
  width: 250px;
  height: 100%;
  background: #fff;
  border-left: solid 1px #ddd;
  padding: 0px 0px 0px 2px;
  z-index: 10;
}
.slideout-menu-frame {
  padding: 0px 0px 0px 10px;
  margin: 0px 0px 0px 0px;
}
.toggle {
  float: left;
  position: relative;
  top: 75px;
  left: -33px;
  /*
  top: 50%;
  left: -35px;
  */
  z-index: 10;
  padding: 0px;
  margin: -55px 0px 0px 0px;
}
.button-toggle {
  cursor: pointer;
  height: 110px;
  width: 20px;
  font-size: 12px;
  display: table-cell;
  vertical-align: bottom;
  color: #333;
  background: #f4f4f4;
  border: solid 1px #c0c2cb;
  /*
  background: #fff;
  border-left: solid 1px #c0c2cb;
  border-top: solid 1px #c0c2cb;
  border-right: solid 1px #fff;
  border-bottom: solid 1px #c0c2cb;
  */
  border-radius: 5px 0px 0px 5px;
  padding: 0px 0px 18px 2px;
  margin: 0px;
}
.button-toggle-label {
  width: 20px;
  transform: rotate(-90deg);
}
.file-input {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
`, "",{"version":3,"sources":["webpack://./styles/app.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;AAEA;;EAGE,2DAAA;EAEA,eAAA;EAEA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAHF;AAMA;EACE,qBAAA;AAJF;AAOA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AALF;AAEA;EAMI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EAEA,eAAA;EACA,WAAA;AANJ;AANA;EAeM,sBAAA;EACA,kBAAA;EACA,mBAAA;AANN;AAXA;EAsBQ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AARR;AAjBA;EA6BQ,sBAAA;EACA,gBAAA;EACA,aAAA;AATR;AAaE;;;EAGE,aAAA;AAXJ;AA3BA;EA0CI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAZJ;AAlCA;;EAmDI,kBAAA;AAbJ;AAgBE;EACE,mBAAA;AAdJ;AAmBA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EAEA,UAAA;EACA,SAAA;EACA,gBAAA;AAlBF;AAWA;EAUI,qBAAA;EACA,kBAAA;AAlBJ;AAOA;EAcM,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;AAlBN;AACA;EAsBI,YAAA;AApBJ;AAFA;EA0BI,UAAA;AArBJ;AAyBA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;EACA,cAAA;AAvBF;AAwBE;EACE,aAAA;AAtBJ;AAaA;EAYI,oBAAA;EACA,gBAAA;AAtBJ;AACA,cAAc;AA2Bd;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AAzBF;AA4BA;;EAEE,mBAAA;AA1BF;AA6BA;EACE,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AA3BF;AA8BA;EACE,UAAA;AA5BF;AA+BA;EACE,YAAA;EACA,qBAAA;EACA,+BAAA;AA7BF;AAgCA;EACE,YAAA;EACA,6BAAA;EACA,WAAA;AA9BF;AAiCA;EACE,eAAA;AA/BF;AAkCA;EACE,gBAAA;AAhCF;AA+BA;;;EAMI,UAAA;EACA,aAAA;EAEA,eAAA;EACA,eAAA;EACA,iBAAA;EAMA,cAAA;EAEA,gBAAA;EACA,YAAA;AAvCJ;AAyCI;;;EACE,cAAA;AArCN;AAwCI;;;EACE,cAAA;EACA,eAAA;AApCN;AAwCE;;EAEE,qBAAA;AAtCJ;AAyCE;EAGI,gBAAA;AAzCN;AAsCE;EAOI,YAAA;AA1CN;AA+CA;EACE,eAAA;EACA,WAAA;AA7CF;AA2CA;EAKI,iBAAA;AA7CJ;AAkDA;EACE,WAAA;AAhDF;AAmDA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAjDF;AAoDA;EACE,mBAAA;EACA,kBAAA;AAlDF;AAqDA;EACE,kBAAA;AAnDF;AAsDA;EACE,eAAA;EACA,UAAA;EACA,YAAA;AApDF;AAuDA;EACE,YAAA;AArDF;AAwDA;EACE,qBAAA;EACA,oBAAA;AAtDF;AAyDA;EACE,WAAA;AAvDF;AA0DA;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAxDF;AA2DA;EACE,WAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EAEA,aAAA;AA1DF;AAoDA;EASI,iBAAA;AA1DJ;AAiDA;EAYM,SAAA;AA1DN;AA+DA;EACE,mBAAA;AA7DF;AACA;;EAEE;AAgEF;EAEI,WAAA;AA/DJ;AAmEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,yDAAA;AAjEF;AAoEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,yDAAA;AAlEF;AAqEA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,yDAAA;AAnEJ;AAsEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,yDAAA;AApEF;AAuEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,yDAAA;AArEF;AAwEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,yDAAA;AAtEF;AAyEA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAvEF;AA0EA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;AAxEF;AA2EA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,yBAAA;AAzEF;AA4EA;EACE,eAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,wBAAA;EACA,WAAA;AA1EF;AA6EA;EACE,yBAAA;EACA,uBAAA;AA3EF;AA8EA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EA5EA;;;GAGC;EA8ED,WAAA;EACA,YAAA;EACA,yBAAA;AA5EF;AA+EA;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EA7EA;;;;;;GAMC;EA+ED,8BAAA;EACA,yBAAA;EACA,WAAA;AA7EF;AAgFA;EACE,WAAA;EACA,yBAAA;AA9EF;AAiFA;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AA/EF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody,\nhtml {\n\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n  font-size: 12px;\n\n  height: 100%;\n  max-height: 100%;\n  padding: 0;\n  margin: 0;\n}\n\na:link {\n  text-decoration: none;\n}\n\n.content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  > .message {\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    display: table;\n\n    font-size: 16px;\n    color: #111;\n\n    .note {\n      vertical-align: middle;\n      text-align: center;\n      display: table-cell;\n    }\n\n    .error {\n      .details {\n        max-width: 500px;\n        font-size: 12px;\n        margin: 20px auto;\n        text-align: left;\n      }\n\n      pre {\n        border: solid 1px #CCC;\n        background: #EEE;\n        padding: 10px;\n      }\n    }\n  }\n  &:not(.with-error) .error,\n  &.with-error .intro,\n  &.with-diagram .intro {\n    display: none;\n  }\n\n  .canvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n\n  .canvas,\n  &.with-error .canvas {\n    visibility: hidden;\n  }\n\n  &.with-diagram .canvas {\n    visibility: visible;\n  }\n}\n\n\n.buttons {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  > li {\n    display: inline-block;\n    margin-right: 10px;\n\n    > a {\n      background: #ddd;\n      border: solid 1px #666;\n      display: inline-block;\n      padding: 5px;\n    }\n  }\n\n  a {\n    opacity: 0.3;\n  }\n\n  a.active {\n    opacity: 1.0;\n  }\n}\n\n#js-properties-panel {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 260px;\n  border-left: 1px solid #ccc;\n  overflow: auto;\n  &:empty {\n    display: none;\n  }\n  > .djs-properties-panel {\n    padding-bottom: 70px;\n    min-height:100%;\n  }\n}\n\n/** widgets **/\n\n.io-control {\n  background: #fafafa;\n  border-radius: 2px;\n  border: solid 1px #afafaf;\n  padding-top: 5px;\n  padding-left: 5px;\n}\n\n.cjs-powered-by,\n.bjs-powered-by {\n  padding-bottom: 2px;\n}\n\n.close {\n  color: #333 !important;\n  font-size: 21px;\n  font-weight: 700 !important;\n  opacity: .6;\n  line-height: 1;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n\n.close:hover {\n  opacity: 1;\n}\n\n.io-control .vr {\n  height: 40px;\n  display: inline-block;\n  border-right: solid 1px #ebe9e9;\n}\n\n.io-control hr {\n  border: none;\n  border-top: solid 1px #ebe9e9;\n  width: 15px;\n}\n\n.io-control-list .vr {\n  margin-right: 0;\n}\n\n.io-control-list {\n  list-style: none;\n\n  a,\n  a:visited,\n  button {\n    padding: 0;\n    outline: none;\n\n    cursor: pointer;\n    font-size: 22px;\n    line-height: 26px;\n\n    @button-color: #c0c0c0;\n    @button-color-hover: @button-color;\n    @button-color-inactive: @button-color;\n\n    color: @button-color;\n\n    background: none;\n    border: none;\n\n    &:hover {\n      color: @button-color-hover;\n    }\n\n    &.inactive {\n      color: @button-color-inactive;\n      cursor: default;\n    }\n  }\n\n  &.io-horizontal,\n  &.io-horizontal li {\n    display: inline-block;\n  }\n\n  &.io-horizontal {\n\n    li + li {\n      margin-left: 5px;\n    }\n\n    a {\n      padding: 2px;\n    }\n  }\n}\n\n.io-about {\n  position: fixed;\n  right: 10px;\n\n  li + li {\n    margin-left: 15px;\n  }\n\n}\n\nbody.shown .io-about {\n  right: 90px;\n}\n\n.io-about a {\n  font-size: 13px;\n  line-height: 20px;\n  font-weight: normal;\n}\n\n.io-about a:hover {\n  background: #F0F0F0;\n  border-radius: 2px;\n}\n\n.io-import {\n  margin-right: 10px;\n}\n\n.io-import-export {\n  position: fixed;\n  left: 10px;\n  bottom: 10px;\n}\n\n.io-import-export .inactive {\n  opacity: 0.3;\n}\n\n.djs-palette {\n  left: 10px !important;\n  top: 10px !important;\n}\n\n.io-about {\n  bottom: 8px;\n}\n\n.io-zoom-controls {\n  width: auto;\n  position: fixed;\n  right: 10px;\n  bottom: 80px;\n}\n\n.io-editing-tools {\n  width: auto;\n  position: fixed;\n  right: 5px;\n  top: 5px;\n\n  display: none;\n\n  .io-control {\n    margin-left: 10px;\n\n    button {\n      margin: 0;\n    }\n  }\n}\n\n.io-zoom-reset {\n  margin-bottom: 10px;\n}\n\n/**\n * import warnings dialog\n */\n.import-warnings {\n  .error-log {\n    width: 100%;\n  }\n}\n\n.icon-open {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='40px' height='40px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' stroke='%23000000' stroke-width='1.2'%3E%3Cg id='SVGRepo_bgCarrier' stroke-width='0'%3E%3C/g%3E%3Cg id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'%3E%3C/g%3E%3Cg id='SVGRepo_iconCarrier'%3E%3Cpath d='M19.5 12V12C19.5 10.5955 19.5 9.89331 19.1629 9.38886C19.017 9.17048 18.8295 8.98298 18.6111 8.83706C18.1067 8.5 17.4045 8.5 16 8.5H14.1569C13.3394 8.5 12.9306 8.5 12.5631 8.34776C12.1955 8.19552 11.9065 7.90489 11.3284 7.32843L10.6716 6.67157C10.0935 6.09351 9.80448 5.80448 9.43694 5.65224C9.0694 5.5 8.66065 5.5 7.84315 5.5H7.5C5.61438 5.5 4.67157 5.5 4.08579 6.08579C3.5 6.67157 3.5 7.61438 3.5 9.5V14.5C3.5 16.3856 3.5 17.3284 4.08579 17.9142C4.67157 18.5 5.61438 18.5 7.5 18.5H12' stroke='%23222222'%3E%3C/path%3E%3Ccircle cx='16.5' cy='16.5' r='2.5' stroke='%23222222'%3E%3C/circle%3E%3Cpath d='M19.5 19.5L21 21' stroke='%23222222' stroke-linecap='round'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.icon-plus-circled {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='40px' height='40px' viewBox='2 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' stroke='%23000000' stroke-width='1.2'%3E%3Cg id='SVGRepo_bgCarrier' stroke-width='0'%3E%3C/g%3E%3Cg id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'%3E%3C/g%3E%3Cg id='SVGRepo_iconCarrier'%3E%3Cpath d='M19.5 14V12.5C19.5 10.6144 19.5 9.67157 18.9142 9.08579C18.3284 8.5 17.3856 8.5 15.5 8.5H14.1569C13.3394 8.5 12.9306 8.5 12.5631 8.34776C12.1955 8.19552 11.9065 7.90489 11.3284 7.32843L10.6716 6.67157C10.0935 6.09351 9.80448 5.80448 9.43694 5.65224C9.0694 5.5 8.66065 5.5 7.84315 5.5H7.5C5.61438 5.5 4.67157 5.5 4.08579 6.08579C3.5 6.67157 3.5 7.61438 3.5 9.5V14.5C3.5 16.3856 3.5 17.3284 4.08579 17.9142C4.67157 18.5 5.61438 18.5 7.5 18.5H15' stroke='%23222222'%3E%3C/path%3E%3Cpath d='M17 18.5H19.5M19.5 18.5H22M19.5 18.5V21M19.5 18.5V16' stroke='%23222222'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.icon-download {\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    background-repeat: no-repeat;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='40px' height='40px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='SVGRepo_bgCarrier' stroke-width='0'%3E%3C/g%3E%3Cg id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'%3E%3C/g%3E%3Cg id='SVGRepo_iconCarrier'%3E%3Cpath d='M12 5H7C5.89543 5 5 5.89543 5 7V16H19V12.5' stroke='%23000000' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M3 16H21V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V16Z' stroke='%23000000' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M18.5 3V9M18.5 9L16 6.5M18.5 9L21 6.5' stroke='%23000000' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.icon-image {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='40px' height='40px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='SVGRepo_bgCarrier' stroke-width='0'%3E%3C/g%3E%3Cg id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'%3E%3C/g%3E%3Cg id='SVGRepo_iconCarrier'%3E%3Cpath d='M13 4H8.8C7.11984 4 6.27976 4 5.63803 4.32698C5.07354 4.6146 4.6146 5.07354 4.32698 5.63803C4 6.27976 4 7.11984 4 8.8V15.2C4 16.8802 4 17.7202 4.32698 18.362C4.6146 18.9265 5.07354 19.3854 5.63803 19.673C6.27976 20 7.11984 20 8.8 20H15.2C16.8802 20 17.7202 20 18.362 19.673C18.9265 19.3854 19.3854 18.9265 19.673 18.362C20 17.7202 20 16.8802 20 15.2V11' stroke='%23000000' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M4 16L8.29289 11.7071C8.68342 11.3166 9.31658 11.3166 9.70711 11.7071L13 15M13 15L15.7929 12.2071C16.1834 11.8166 16.8166 11.8166 17.2071 12.2071L20 15M13 15L15.25 17.25' stroke='%23000000' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M18 3V8M18 8L16 6M18 8L20 6' stroke='%23000000' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.icon-publish {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg fill='%23000000' width='40px' height='40px' viewBox='-2 0 48 36' version='1.1' preserveAspectRatio='xMidYMid meet' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' stroke='%23000000' stroke-width='0.00036'%3E%3Cg id='SVGRepo_bgCarrier' stroke-width='0'%3E%3C/g%3E%3Cg id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round' stroke='%23CCCCCC' stroke-width='1.0799999999999998'%3E%3C/g%3E%3Cg id='SVGRepo_iconCarrier'%3E%3Ctitle%3Edeploy-line%3C/title%3E%3Cpath class='clr-i-outline clr-i-outline-path-1' d='M33,2H22.1a1,1,0,0,0,0,2h8.53l-8.82,9a1,1,0,1,0,1.43,1.4L32,5.46V13.9a1,1,0,0,0,2,0V3A1,1,0,0,0,33,2Z'%3E%3C/path%3E%3Cpath class='clr-i-outline clr-i-outline-path-2' d='M11.54,10.73l-9,5.17a1,1,0,0,0-.5.87v11a1,1,0,0,0,.5.87l9,5.15a1,1,0,0,0,1,0l9-5.15a1,1,0,0,0,.5-.87v-11a1,1,0,0,0-.5-.87l-9-5.17A1,1,0,0,0,11.54,10.73ZM11,31.08l-7-4V18.44l7,4ZM12,21,4.81,16.87,12,12.78l7.21,4.12Zm8,6.09-7,4V22.44l7-4Z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.icon-publish-disabled {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg fill='%23b2b2b2' width='40px' height='40px' viewBox='-2 0 48 36' version='1.1' preserveAspectRatio='xMidYMid meet' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' stroke='%23000000' stroke-width='0.00036'%3E%3Cg id='SVGRepo_bgCarrier' stroke-width='0'%3E%3C/g%3E%3Cg id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round' stroke='%23CCCCCC' stroke-width='1.0799999999999998'%3E%3C/g%3E%3Cg id='SVGRepo_iconCarrier'%3E%3Ctitle%3Edeploy-line%3C/title%3E%3Cpath class='clr-i-outline clr-i-outline-path-1' d='M33,2H22.1a1,1,0,0,0,0,2h8.53l-8.82,9a1,1,0,1,0,1.43,1.4L32,5.46V13.9a1,1,0,0,0,2,0V3A1,1,0,0,0,33,2Z'%3E%3C/path%3E%3Cpath class='clr-i-outline clr-i-outline-path-2' d='M11.54,10.73l-9,5.17a1,1,0,0,0-.5.87v11a1,1,0,0,0,.5.87l9,5.15a1,1,0,0,0,1,0l9-5.15a1,1,0,0,0,.5-.87v-11a1,1,0,0,0-.5-.87l-9-5.17A1,1,0,0,0,11.54,10.73ZM11,31.08l-7-4V18.44l7,4ZM12,21,4.81,16.87,12,12.78l7.21,4.12Zm8,6.09-7,4V22.44l7-4Z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.button-properties {\n  color:rgb(40, 0, 238);\n  background: #fff;\n  font-size: 13px;\n  border: none;\n  cursor: pointer;\n  margin: -5px;\n}\n\n.button-publish {\n  color:#333;\n  background: #fafafa;\n  border: solid 1px #c0c2cb;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 2px;\n  padding: 4px 2px 0px 6px;\n  margin: 5px 10px 15px;\n}\n\n.button-publish-properties {\n  color:#333;\n  background: #fafafa;\n  border: solid 1px #c0c2cb;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 2px;\n  padding: 4px 2px 0px 4px;\n  margin: 5px 0px 15px 12px;\n}\n\n.slideout-menu {\n  position: fixed;\n  top: 0;\n  right: 0px;\n  width: 250px;\n  height: 100%;\n  background: #fff;\n  border-left: solid 1px #ddd;\n  padding: 0px 0px 0px 2px;\n  z-index: 10;\n}\n\n.slideout-menu-frame {\n  padding: 0px 0px 0px 10px;\n  margin: 0px 0px 0px 0px;\n}\n\n.toggle {\n  float: left;\n  position: relative;\n  top: 75px;\n  left: -33px;\n  /*\n  top: 50%;\n  left: -35px;\n  */\n  z-index: 10;\n  padding: 0px;\n  margin: -55px 0px 0px 0px;\n}\n\n.button-toggle {\n  cursor: pointer;\n  height: 110px;\n  width: 20px;\n  font-size: 12px;\n  display: table-cell;\n  vertical-align: bottom;\n  color:#333;\n  background: #f4f4f4;\n  border: solid 1px #c0c2cb;\n  /*\n  background: #fff;\n  border-left: solid 1px #c0c2cb;\n  border-top: solid 1px #c0c2cb;\n  border-right: solid 1px #fff;\n  border-bottom: solid 1px #c0c2cb;\n  */\n  border-radius: 5px 0px 0px 5px;\n  padding: 0px 0px 18px 2px;\n  margin: 0px;\n}\n\n.button-toggle-label {\n  width: 20px;\n  transform: rotate(-90deg);\n}\n\n.file-input {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
